import classNames from 'classnames';
import { random } from 'lodash';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import reminder1 from '../../common/assets/images/reminder-1.gif';
import reminder2 from '../../common/assets/images/reminder-2.gif';
import reward1 from '../../common/assets/images/reward-1.gif';
import reward2 from '../../common/assets/images/reward-2.gif';
import { selectRewardGif } from '../../services/controllers/common/CommonSelector';
import { setRewardGif } from '../../services/controllers/common/CommonSlice';
import Icon, { ICONS } from '../SVG/Icon';
import './RewardGif.scss';

const rewardGifImages = [
  {
    label: 'reward.text.gif1',
    src: reward1,
  },
  {
    label: 'reward.text.gif2',
    src: reward2,
  },
];

const reminderGifImages = [
  {
    label: 'reward.text.reminder1',
    src: reminder1,
  },
  {
    label: 'reward.text.reminder2',
    src: reminder2,
  },
];

const RewardGif: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const gifStatus = useSelector(selectRewardGif);

  const onClose = () => {
    dispatch(
      setRewardGif({
        ...gifStatus,
        visible: false,
      }),
    );
  };

  useEffect(() => {
    const hideGifTimeout = setTimeout(gifStatus.visible ? onClose : () => {}, 5000);

    return () => clearTimeout(hideGifTimeout);
  }, [gifStatus.visible]);

  const gif = useMemo(() => {
    if (gifStatus.visible) {
      const images = gifStatus.isReward ? [...rewardGifImages] : [...reminderGifImages];
      const randomIndex = random(0, images.length - 1);
      return images[randomIndex];
    }
    return null;
  }, [gifStatus.visible]);

  const rewardGifClasses = classNames('reward-gif', {
    'reward-gif--active': gifStatus.visible,
  });

  return (
    <div className={rewardGifClasses}>
      <div className="reward-gif__content">
        <Icon className="reward-gif__close" onClick={onClose} component={ICONS.CLOSE_ICON} />
        <p>{t(gif?.label || '')}</p>
        {gif ? <img className="reward-gif__image" src={gif.src} alt="reward" /> : <div className="reward-gif__image" />}
      </div>
      {gifStatus.isReward ? (
        <div className="reward-gif__coins">
          <div>
            <span>+{gifStatus.coins}</span> {t('common.text.coinAmount', { amount: '', count: gifStatus.coins })}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default RewardGif;
